exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-card[data-v-46ee226d] {\n  font-size: 12pt;\n}\n.v-card .v-divider[data-v-46ee226d] {\n  margin: 10px 0;\n}\n", ""]);

// exports
